var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basePopup',{ref:"basePopup",attrs:{"tips":_vm.tips}},[_c('font-size-range',{model:{value:(_vm.articleFontSize),callback:function ($$v) {_vm.articleFontSize=$$v},expression:"articleFontSize"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }